
<p class="bl-text-style--tertiary-text-2">
  @if (visibleCards && visibleCards.length) {
  <span class="bl-font-color--error bl-font-weight--800">*</span> indicates a required field.
  }
</p>
<!-- Workflow Cards -->
<div *ngFor="let card of visibleCards; let cardIndex = index">
  <cu-dynamic-card [flow]="flow" [page]="page" [card]="card" [cardIndex]="cardIndex" [pageSubmitted$]="workflowPageNavigationService.pageSubmitted$"></cu-dynamic-card>
</div>
